'use strict';

var gqlUtils = require('@liquorice/gql-utils');
var FIELD_BASE_FRAGMENT = require('./FIELD_BASE_FRAGMENT.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const parseFieldBase = gqlUtils.createFragmentParser(FIELD_BASE_FRAGMENT.FIELD_BASE_FRAGMENT, (data)=>{
    if (!data) return null;
    var _data_id, _data_handle, _data_label, _data_placeholder;
    return _extends({}, data, {
        id: (_data_id = data.id) != null ? _data_id : '',
        handle: (_data_handle = data.handle) != null ? _data_handle : '',
        required: !!data.required,
        label: (_data_label = data.label) != null ? _data_label : '',
        placeholder: (_data_placeholder = data.placeholder) != null ? _data_placeholder : ''
    });
});

module.exports = parseFieldBase;
